import { render } from "./spot-monitor.vue?vue&type=template&id=fff4356a"
import script from "./spot-monitor.vue?vue&type=script&lang=js"
export * from "./spot-monitor.vue?vue&type=script&lang=js"

import "./spot-monitor.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__